module.exports = {
      id: "automobile-usage",
      viewBox: "0 0 31.664 23.083",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#automobile",
      toString: function () {
        return this.url;
      }
    }